import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    BooleanInput
} from 'react-admin';

import { required, maxLength, minLength, email, number } from './../../utils/validations';

export const CityAdminList = (props) => (
    <List {...props} title="City Admins" bulkActionButtons={false}>
        <Datagrid>
            <TextField source="fullName" label="Name" />
            <TextField source="userName" label="Username" />
            <TextField source="emailId" label="Email" />
            <TextField source="mobileNo" label="Mobile" />
            <TextField source="city.name" label="City" />
            <EditButton />
        </Datagrid>
    </List>
);

const validateName = [required(), minLength(2), maxLength(15)];
const validatePhone = [required(), number('Must be a valid phone number'), minLength(10), maxLength(15)];
const validatePassword = [required(), minLength(5)];

export const CityAdminEdit = (props) => (
    <Edit title="Edit City Admin" {...props}>
        <SimpleForm redirect="list" {...props}>
            <TextInput label="Name" source="fullName" validate={validateName} />
            <TextInput disabled label="Username" source="userName" />
            <TextInput label="Email Address" source="emailId" validate={email()} />
            <TextInput label="Mobile Number" source="mobileNo" validate={validatePhone} />
            <BooleanInput label="City Admin" source="cityAdmin" />
            <ReferenceInput label="City" source="cityId" reference="cities" validate={[required()]}>
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export const CityAdminCreate = (props) => (
    <Create title="Create City Admin" {...props}>
        <SimpleForm redirect="list">
            <TextInput label="First Name" source="firstName" validate={validateName} />
            <TextInput label="Last Name" source="lastName" validate={validateName} />
            <TextInput label="Username" source="userName" validate={validateName} />
            <TextInput label="Password" source="password" type="password" validate={validatePassword} />
            <TextInput label="Email Address" source="emailId" validate={email()} />
            <TextInput label="Mobile Number" source="mobileNo" validate={validatePhone} />
            <BooleanInput label="City Admin" source="cityAdmin" />
            <ReferenceInput label="City" source="cityId" reference="cities" validate={[required()]}>
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);
